import svgHelper from './svg-helper';

const setImage = (currentState, newState) => {
  return newState;
};

const colorChange = (currentState, color, { id }) => {
  const colorGroups = currentState.colorGroups.map((group) => {
    if (group.id === id) {
      group.color = color;
    }
    return group;
  });

  const newState = {
    ...currentState,
    colorGroups
  };

  svgHelper.updateElement(newState);

  return newState;
};

export default {
  setImage,
  colorChange,
};



// WEBPACK FOOTER //
// ./src/ui/svg/svg-actions.js